import { useState, useEffect } from "react";
import PaginationTable from "../pagination/Pagination4";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import axios from "axios";

const RegenerateCommissionNFSAStateDetails = ({
  month,
  year,
  allotMonth,
  allotYear,
  distCode,
  distMonthName,
  alotMonthName,
  districtName,
}) => {
  const [commissionData, setCommissionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nfsaData, setNFSAData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchNFSAQuery, setSearchNFSAQuery] = useState("");
  const [searchStateQuery, setSearchStateQuery] = useState("");
  const [regenerateStatus, setRegenerateStatus] = useState(null);

  
  useEffect(() => {
    const fetCommissionCost = async () => {
      try {
        const commissioncostresponse = await fetch(
          `${process.env.REACT_APP_URL}/api/commission/commission-cost`,
        );

        if (!commissioncostresponse.ok) {
          throw new Error("Failed to fetch State commission data");
        }

        const data = await commissioncostresponse.json();
        setCommissionData(data);
      } catch (error) {
        console.error("Fetch Error:", error);
        setError(error);
      }
    };

    fetCommissionCost();
  }, []);

  useEffect(() => {
  const initPageLoad = async () => {
    try {
      setLoading(true);

      const queryParam = new URLSearchParams({
        month,
        year,
        allotMonth,
        allotYear,
        distCode,
      }).toString();

      const statusResponse = await fetch(
        `${process.env.REACT_APP_URL}/api/commission/regenerate-state-fps-commission-status?${queryParam}`,
        { method: "GET" }
      );

      if (!statusResponse.ok) {
        throw new Error(
          "Failed to get regenerate state FPS commission status"
        );
      }

      const statusData = await statusResponse.json();
      setRegenerateStatus(statusData);

      const queryParams = new URLSearchParams({
        month,
        year,
        allotMonth,
        allotYear,
        distCode,
      }).toString();

      const nfsaUrl = `${process.env.REACT_APP_URL}/api/commission/regenerate-nfsa-fps-commission?${queryParams}`;
      const stateUrl = `${process.env.REACT_APP_URL}/api/commission/regenerate-state-fps-commission?${queryParams}`;

      const [nfsaResponse, stateResponse] = await Promise.all([
        fetch(nfsaUrl),
        fetch(stateUrl),
      ]);

      if (!nfsaResponse.ok || !stateResponse.ok) {
        throw new Error("Failed to fetch commission data");
      }

      const [nfsaData, stateData] = await Promise.all([
        nfsaResponse.json(),
        stateResponse.json(),
      ]);

      setNFSAData(nfsaData);
      setStateData(stateData);
    } catch (error) {
      console.error("Init Load Error:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  initPageLoad();
}, [month, year, allotMonth, allotYear, distCode]);


 

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === "all" ? nfsaData.length : parseInt(value, 10));
    setPage(0);
  };

  const filteredNFSAData = nfsaData.filter((item) => {
    if (!searchNFSAQuery) return true;
    const query = searchNFSAQuery.toLowerCase();
    return Object.values(item).some(
      (value) => value && value.toString().toLowerCase().includes(query),
    );
  });

  const filteredStateData = stateData.filter((item) => {
    if (!searchStateQuery) return true;
    const query = searchStateQuery.toLowerCase();
    return Object.values(item).some(
      (value) => value && value.toString().toLowerCase().includes(query),
    );
  });

  const paginatedNFSAData = filteredNFSAData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const paginatedStateData = filteredStateData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const totalsNFSA = filteredNFSAData.reduce(
    (acc, item) => {
      acc.shop_total_qty += Number(item.shop_total_qty) || 0;
      acc.nfsa_amount += Number(item.nfsa_amount) || 0;
      acc.impds_trans_count += Number(item.impds_trans_count) || 0;
      acc.impds_total_qty += Number(item.impds_total_qty) || 0;
      acc.amount_recovered += Number(item.amount_recovered) || 0;
      acc.final_commission += Number(item.final_commission) || 0;
      acc.count += 1;
      return acc;
    },
    {
      shop_total_qty: 0,
      nfsa_amount: 0,
      impds_trans_count: 0,
      impds_total_qty: 0,
      amount_recovered: 0,
      final_commission: 0,
      count: 0,
    },
  );

  const totalsState = filteredStateData.reduce(
    (acc, item) => {
      acc.nfsa_shop_total_qty += Number(item.nfsa_shop_total_qty) || 0;
      acc.nfsa_state_amount += Number(item.nfsa_state_amount) || 0;
      acc.state_shop_total_qty += Number(item.state_shop_total_qty) || 0;
      acc.nfsa_extra_qty += Number(item.nfsa_extra_qty) || 0;
      acc.state_total_qty +=
        Number(item.state_shop_total_qty + item.nfsa_extra_qty) || 0;
      acc.state_amount += Number(item.state_amount) || 0;
      acc.total_amount +=
        Number(item.nfsa_state_amount + item.state_amount) || 0;
      acc.count += 1;
      return acc;
    },
    {
      nfsa_shop_total_qty: 0,
      nfsa_state_amount: 0,
      state_shop_total_qty: 0,
      nfsa_extra_qty: 0,
      state_total_qty: 0,
      state_amount: 0,
      total_amount: 0,
      count: 0,
    },
  );

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        nfsaData,
        stateData,
        month,
        year,
        allotMonth,
        allotYear,
        distCode,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/commission/regenerate-nfsa-state-fps-commisison`,
        payload,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      alert("Date is updated or inserted Successfully!");

      const queryParam = new URLSearchParams({
      month,
      year,
      allotMonth,
      allotYear,
      distCode,
    }).toString();

    const statusResponse = await fetch(
      `${process.env.REACT_APP_URL}/api/commission/regenerate-state-fps-commission-status?${queryParam}`
    );

    if (!statusResponse.ok) {
      throw new Error("Failed to get updated regenerate status");
    }

    const updatedStatus = await statusResponse.json();
    setRegenerateStatus(updatedStatus);

    } catch (error) {
      console.error("Submit Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadNFSAExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("NFSA Commission");

    const totalColumns = 16;

    const reportTitle = `Regenerate NFSA Commission Report for Distribution: ${distMonthName}'${year}, Allotment: ${alotMonthName}'${allotYear} and District: ${districtName}`;

    // ===== TITLE =====
    worksheet.mergeCells(1, 1, 1, totalColumns);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = reportTitle;
    titleCell.font = { size: 12, bold: true };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };

    // ===== HEADERS =====
    const headers = [
      "S.No",
      "District",
      "Office / Mandal",
      "Shop No.",
      "FPS Dealer Name",
      "Bank Name",
      "Branch Name",
      "IFSC Code",
      "PAN No",
      "Account No",
      "Total Quantity Distributed (Kg) (A)",
      `Amount Payable (Rs ${commissionData.nfsaCost}/kg) (B=A*${commissionData.nfsaCost})`,
      "Total IMPDS Transaction",
      "Total Quantity Distributed under IMPDS (Kg)",
      "Amount Recovered (C)",
      "Net Amount Payable (D=B-C)",
    ];

    worksheet.addRow(headers);

    const headerRow = worksheet.getRow(2);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFDDDDDD" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // ===== DATA ROWS =====
    filteredNFSAData.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.dist_name_en,
        item.afso_name_en,
        item.fps_id,
        item.dealer_name,
        item.bank_name,
        item.branch_name,
        item.ifsc_code,
        item.pan_no,
        item.ac_no,
        Number(item.shop_total_qty),
        Number(item.nfsa_amount),
        Number(item.impds_trans_count),
        Number(item.impds_total_qty),
        Number(item.amount_recovered),
        Number(item.final_commission),
      ]);

      // Alignment
      for (let i = 1; i <= 10; i++)
        row.getCell(i).alignment = { horizontal: "left" };
      for (let i = 11; i <= 16; i++)
        row.getCell(i).alignment = { horizontal: "right" };

      row.getCell(11).numFmt = "0.000";
      row.getCell(12).numFmt = "0.00";
      row.getCell(13).numFmt = "0";
      row.getCell(14).numFmt = "0.000";
      row.getCell(15).numFmt = "0.00";
      row.getCell(16).numFmt = "0.00";
    });

    const totalRow = worksheet.addRow([
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Total",
      totalsNFSA.shop_total_qty,
      totalsNFSA.nfsa_amount,
      totalsNFSA.impds_trans_count,
      totalsNFSA.impds_total_qty,
      totalsNFSA.amount_recovered,
      totalsNFSA.final_commission,
    ]);

    const totalRowNumber = totalRow.number;
    worksheet.mergeCells(totalRowNumber, 1, totalRowNumber, 10);

    totalRow.font = { bold: true };
    totalRow.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "double" },
        right: { style: "thin" },
      };
      cell.alignment =
        colNumber <= 10 ? { horizontal: "left" } : { horizontal: "right" };
    });

    totalRow.getCell(11).numFmt = "0.000";
    totalRow.getCell(12).numFmt = "0.00";
    totalRow.getCell(13).numFmt = "0";
    totalRow.getCell(14).numFmt = "0.000";
    totalRow.getCell(15).numFmt = "0.00";
    totalRow.getCell(16).numFmt = "0.00";

    worksheet.columns.forEach((col) => {
      let maxLength = 12;
      col.eachCell({ includeEmpty: true }, (cell) => {
        const value = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, value.length);
      });
      col.width = Math.min(maxLength + 2, 30);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "Regenerate_NFSA_Commission.xlsx");
  };

  const handleDownloadStateExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("State Commission");

    const totalColumns = 17;

    const reportTitle = `Regenerate State Commission Report for Distribution: ${distMonthName}'${year}, Allotment: ${alotMonthName}'${allotYear} and District: ${districtName}`;

    // ===== TITLE =====
    worksheet.mergeCells(1, 1, 1, totalColumns);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = reportTitle;
    titleCell.font = { size: 12, bold: true };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };

    // ===== HEADERS =====
    const headers = [
      "S.No",
      "District",
      "Office / Mandal",
      "Shop No.",
      "FPS Dealer Name",
      "Bank Name",
      "Branch Name",
      "IFSC Code",
      "PAN No",
      "Account No",
      "NFSA Qty (Kg) (A)",
      `Amount Payable (Rs ${commissionData.nfsaStateCost}/kg) (B=A*${commissionData.nfsaStateCost})`,
      "State Qty (Kg) (C)",
      "NFSA Extra Qty (Kg) (D)",
      "Total Qty (Kg) (E=C+D)",
      `Total State Amount (F=E*${commissionData.stateCost})`,
      "Total (B+F)",
    ];

    worksheet.addRow(headers);

    const headerRow = worksheet.getRow(2);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFDDDDDD" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    filteredStateData.forEach((item, index) => {
      const totalQty =
        Number(item.state_shop_total_qty) + Number(item.nfsa_extra_qty);

      const totalAmount =
        Number(item.nfsa_state_amount) + Number(item.state_amount);

      const row = worksheet.addRow([
        index + 1,
        item.dist_name_en,
        item.afso_name_en,
        item.fps_id,
        item.dealer_name,
        item.bank_name,
        item.branch_name,
        item.ifsc_code,
        item.pan_no,
        item.ac_no,
        Number(item.nfsa_shop_total_qty),
        Number(item.nfsa_state_amount),
        Number(item.state_shop_total_qty),
        Number(item.nfsa_extra_qty),
        totalQty,
        Number(item.state_amount),
        totalAmount,
      ]);

      for (let i = 1; i <= 10; i++) {
        row.getCell(i).alignment = { horizontal: "left" };
      }
      for (let i = 11; i <= 17; i++) {
        row.getCell(i).alignment = { horizontal: "right" };
      }

      row.getCell(11).numFmt = "0.000";
      row.getCell(12).numFmt = "0.00";
      row.getCell(13).numFmt = "0.000";
      row.getCell(14).numFmt = "0.000";
      row.getCell(15).numFmt = "0.000";
      row.getCell(16).numFmt = "0.00";
      row.getCell(17).numFmt = "0.00";
    });

    // ===== TOTAL ROW (NO GAP) =====
    const totalRow = worksheet.addRow([
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Total",
      totalsState.nfsa_shop_total_qty,
      totalsState.nfsa_state_amount,
      totalsState.state_shop_total_qty,
      totalsState.nfsa_extra_qty,
      totalsState.state_total_qty,
      totalsState.state_amount,
      totalsState.total_amount,
    ]);

    const totalRowNumber = totalRow.number;
    worksheet.mergeCells(totalRowNumber, 1, totalRowNumber, 10);

    totalRow.font = { bold: true };

    totalRow.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "double" },
        right: { style: "thin" },
      };

      cell.alignment =
        colNumber <= 10 ? { horizontal: "left" } : { horizontal: "right" };
    });

    totalRow.getCell(11).numFmt = "0.000";
    totalRow.getCell(12).numFmt = "0.00";
    totalRow.getCell(13).numFmt = "0.000";
    totalRow.getCell(14).numFmt = "0.000";
    totalRow.getCell(15).numFmt = "0.000";
    totalRow.getCell(16).numFmt = "0.00";
    totalRow.getCell(17).numFmt = "0.00";

    worksheet.columns.forEach((col) => {
      let maxLength = 12;
      col.eachCell({ includeEmpty: true }, (cell) => {
        const value = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, value.length);
      });
      col.width = Math.min(maxLength + 2, 30);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "Regenerate_State_Commission.xlsx");
  };

  return (
    <div style={{ justifyContent: "center", marginBottom: "10px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "90%",
          margin: "0 auto 20px auto",
        }}
      >
        {<div style={{ width: "150px" }}></div>}

        <div style={{ align: "center" }}>
          <PaginationTable
            count={filteredNFSAData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="Search "
            value={searchNFSAQuery}
            onChange={(e) => setSearchNFSAQuery(e.target.value)}
            style={{ padding: "8px", width: "200px" }}
          />
        </div>
      </div>

      <div
        style={{ marginTop: "20px", textAlign: "center", marginBottom: "60px" }}
      >
        <table width="90%" border="1" cellPadding="5" cellSpacing="0">
          <thead style={{ position: "sticky", top: 0 }}>
            <tr className="tableheader">
              <th colSpan={16}>
                Regenerate NFSA Commission Report for Distribution:{" "}
                {distMonthName}'{year} , Allotment: {alotMonthName}'{allotYear}{" "}
                and District: {districtName}
              </th>
            </tr>
            <tr className="tableheader">
              <th>S.No</th>
              <th>District</th>
              <th>Office / Mandal</th>
              <th>Shop No.</th>
              <th>FPS Dealer Name</th>
              <th>Bank Name</th>
              <th>Branch Name</th>
              <th>IFSC Code</th>
              <th>PAN No</th>
              <th>Account No</th>
              <th>
                Total Quantity Distributed (in kg) <br />
                <font style={{ color: "orange" }}>(A)</font>
              </th>
              <th>
                Amount Payable Towards Commission(Rs. {commissionData.nfsaCost}
                /Kg) <br />
                <font style={{ color: "orange" }}>
                  (B=A * {commissionData.nfsaCost})
                </font>
              </th>
              <th>Total IMPDS Transaction</th>
              <th>Total Quantity Distributed under IMPDS (in kg)</th>
              <th>
                Amount Recovered <br />
                <font style={{ color: "orange" }}>(C)</font>
              </th>
              <th>
                Net Amount Payable (Rs.) <br />
                <font style={{ color: "orange" }}>(D=B-C)</font>
              </th>
            </tr>
          </thead>
          <tbody>
            {paginatedNFSAData.length === 0 ? (
              <tr>
                <td
                  colSpan={16}
                  style={{ textAlign: "center", fontWeight: "bold" }}
                >
                  No Records Found
                </td>
              </tr>
            ) : (
              paginatedNFSAData.map((item, index) => (
                <tr key={index}>
                  <td>
                    {rowsPerPage === "all"
                      ? index + 1
                      : index + 1 + page * rowsPerPage}
                  </td>
                  <td>{item.dist_name_en}</td>
                  <td>{item.afso_name_en}</td>
                  <td>{item.fps_id}</td>
                  <td>{item.dealer_name}</td>
                  <td>{item.bank_name}</td>
                  <td>{item.branch_name}</td>
                  <td>{item.ifsc_code}</td>
                  <td>{item.pan_no}</td>
                  <td>{item.ac_no}</td>
                  <td style={{ textAlign: "right" }}>
                    {item.shop_total_qty.toFixed(3)}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {item.nfsa_amount.toFixed(2)}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {item.impds_trans_count}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {item.impds_total_qty.toFixed(3)}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {item.amount_recovered}
                  </td>
                  {
                    <td style={{ textAlign: "right" }}>
                      {item.final_commission.toFixed(2)}
                    </td>
                  }
                </tr>
              ))
            )}
          </tbody>
          <tfoot>
            <tr style={{ fontWeight: "bold" }} className="tableheader">
              <td colSpan={10} style={{ textAlign: "center" }}>
                Total
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsNFSA.shop_total_qty.toFixed(3)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsNFSA.nfsa_amount.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsNFSA.impds_trans_count}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsNFSA.impds_total_qty.toFixed(3)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsNFSA.amount_recovered.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsNFSA.final_commission.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colspan="17">
                <button
                  onClick={handleDownloadNFSAExcel}
                  className="button button2"
                >
                  Download NFSA Excel
                </button>
              </td>
            </tr>
          </tfoot>
        </table>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "90%",
            margin: "0 auto 0px auto",
          }}
        >
          {<div style={{ width: "150px" }}></div>}

          <div
            style={{
              marginTop: "120px",
              textAlign: "center",
              marginBottom: "0px",
            }}
          ></div>

          <div style={{ align: "center" }}>
            <PaginationTable
              count={filteredStateData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>

          <div>
            <input
              type="text"
              placeholder="Search "
              value={searchStateQuery}
              onChange={(e) => setSearchStateQuery(e.target.value)}
              style={{ padding: "8px", width: "200px" }}
            />
          </div>
        </div>

        <table width="90%" border="1" cellPadding="5" cellSpacing="0">
          <thead style={{ position: "sticky", top: 0 }}>
            <tr className="tableheader">
              <th colSpan={17}>
                Regenerate State Commission Report for Distribution:{" "}
                {distMonthName}'{year} , Allotment: {alotMonthName}'{allotYear}{" "}
                and District: {districtName}
              </th>
            </tr>
            <tr className="tableheader">
              <th>S.No</th>
              <th>District</th>
              <th>Office / Mandal</th>
              <th>Shop No.</th>
              <th>FPS Dealer Name</th>
              <th>Bank Name</th>
              <th>Branch Name</th>
              <th>IFSC Code</th>
              <th>PAN No</th>
              <th>Account No</th>
              <th>
                NFSA Quantity (in Kg) <br />
                <font style={{ color: "orange" }}>(A)</font>
              </th>
              <th>
                Amount Payable Towards Commission (Rs{" "}
                {commissionData.nfsaStateCost} /kg) <br />
                <font style={{ color: "orange" }}>
                  (B=A*{commissionData.nfsaStateCost})
                </font>
              </th>
              <th>
                State Quantity (in Kg)
                <br />
                <font style={{ color: "orange" }}>(C)</font>
              </th>
              <th>
                NFSA Extra Quantity (in Kg)
                <br />
                <font style={{ color: "orange" }}>(D)</font>
              </th>
              <th>
                Total Quantity (in Kg)
                <br />
                <font style={{ color: "orange" }}>(E=C+D)</font>
              </th>
              <th>
                Total
                <br />
                State
                <br />
                Amount <br />
                <font style={{ color: "orange" }}>
                  (F=E*{commissionData.stateCost})
                </font>
              </th>
              <th>
                Total
                <br />
                (B+F)
              </th>
            </tr>
          </thead>
          <tbody>
           {paginatedStateData.length === 0 ? (
              <tr>
                <td
                  colSpan={17}
                  style={{ textAlign: "center", fontWeight: "bold" }}
                >
                  No Records Found
                </td>
              </tr>
            ) : (
            paginatedStateData.map((item, index) => (
              <tr key={index}>
                <td>
                  {rowsPerPage === "all"
                    ? index + 1
                    : index + 1 + page * rowsPerPage}
                </td>
                <td>{item.dist_name_en}</td>
                <td>{item.afso_name_en}</td>
                <td>{item.fps_id}</td>
                <td>{item.dealer_name}</td>
                <td>{item.bank_name}</td>
                <td>{item.branch_name}</td>
                <td>{item.ifsc_code}</td>
                <td>{item.pan_no}</td>
                <td>{item.ac_no}</td>
                <td style={{ textAlign: "right" }}>
                  {item.nfsa_shop_total_qty.toFixed(3)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {item.nfsa_state_amount.toFixed(2)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {item.state_shop_total_qty.toFixed(3)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {item.nfsa_extra_qty.toFixed(3)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {(item.state_shop_total_qty + item.nfsa_extra_qty).toFixed(3)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {item.state_amount.toFixed(2)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {(item.nfsa_state_amount + item.state_amount).toFixed(2)}
                </td>
              </tr>
            ))
            )}
          </tbody>
          <tfoot>
            <tr style={{ fontWeight: "bold" }} className="tableheader">
              <td colSpan={10} style={{ textAlign: "center" }}>
                Total
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsState.nfsa_shop_total_qty.toFixed(3)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsState.nfsa_state_amount.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsState.state_shop_total_qty.toFixed(3)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsState.nfsa_extra_qty.toFixed(3)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsState.state_total_qty.toFixed(3)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsState.state_amount.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>
                {totalsState.total_amount.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colspan="17">
                <button
                  onClick={handleDownloadStateExcel}
                  className="button button2"
                >
                  Download State Excel
                </button>
              </td>
            </tr>
          </tfoot>
        </table>

        <div style={{ textAlign: "center", marginTop: "25px" }}>
          {regenerateStatus === 0 ? (
            <button onClick={handleSubmit} className="button button2">
              Submit to Regenerate Commission
            </button>
          ) : (
            <div className="mainhead" style={{ textDecoration: "none",fontSize:"25px" }}>
              {{
                [-1]: "Please close for the month to regenerate the bank details",
                [1]: "Please regenerate data to download text file",
                [2]: "Data is successfully regenerated",
              }[regenerateStatus] || null}
            </div>
          )}
        </div>


      </div>
    </div>
  );
};
export default RegenerateCommissionNFSAStateDetails;
